import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import TableCell from "@mui/material/TableCell";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import LockResetIcon from '@mui/icons-material/LockReset';

import { Button, IconButton, Tooltip } from "@mui/material";
import { Logout, Settings } from "@mui/icons-material";
import moment from "moment";
import { useState } from "react";

const UserRow = ({ row, updateForm, index, resetPass, handleEnableDisable, handleUserCheckUncheck }) => {
  const [isVisible, setIsVisible] = useState(false);

  const compareDate = (inter) => {
    const limitDate = moment(row.passwordUpdatedAt.date).add(inter, "days");
    return limitDate.diff(moment(), "days") + " Days";
  };

  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.email}
        <br />
        <br />
        {row.uid}
        <br />
        <br />
        {row.phoneNumber}
      </TableCell>
      <TableCell align="center" key={index}>
        Email: {row.emailVerified ? <CheckIcon /> : <CloseIcon />}
        <br />
        <br />
        Phone: {row.emailVerified ? <CheckIcon /> : <CloseIcon />}
      </TableCell>
      <TableCell align="center" key={index}>
        <Button
          size="small"
          variant="contained"
          color={row?.disabled ? "success" : "warning"}
          onClick={() => {
            handleEnableDisable(row);
          }}
          sx={{ mr: 1, mb: { xs: 1, sm: 0 } }}
        >
          {row?.disabled ? "Enable" : "Disable"}
        </Button>
        <Button
          size="small"
          variant="contained"
          color={row?.emailVerified ? "warning" : "success"}
          onClick={() => {
            handleUserCheckUncheck(row);
          }}
        >
          {row?.emailVerified ? "Uncheck" : "Check"}
        </Button>
      </TableCell>
      <TableCell align="center" key={index}>
        {moment(row.passwordUpdatedAt.date).format("YYYY-MM-DD H:m:s")}
      </TableCell>
      <TableCell align="center" key={index}>
        {compareDate(45)}
      </TableCell>
      <TableCell align="center" key={index}>
        <strong>Bloqueio:</strong> {compareDate(60)} <br />{" "}
        <strong>Desativar:</strong> {compareDate(120)}<br />{" "}
        <strong>Reset Pass:</strong> {compareDate(120)}
      </TableCell>
      {/* <TableCell align="center" key={index}>
        <Button variant="contained" onClick={() => setIsVisible(!isVisible)}>
          {isVisible? 'Hidden' : 'See'}
        </Button>
        {isVisible && jsonToArray(row.customClaims).map((e) => {
          return (
            <p>
              <strong>{e.chave}:</strong>
              {e.valor}
            </p>
          );
        })}
      </TableCell> */}
      <TableCell align="center" key={index}>
        <Tooltip title="Edit Tags">
          <IconButton
            onClick={() => {
              updateForm(row, "tags");
            }}
          >
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Edit User">
          <IconButton
            onClick={() => {
              updateForm(row, "user");
            }}
          >
            <Settings fontSize="small" />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Refresh Pass">
          <IconButton
            onClick={() => {
              resetPass(row);
            }}
          >
            <LockResetIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
};

export default UserRow;
